import React from 'react';
import Factura from '../../components/factura/Factura';
import FacturaPdf from '../../components/factura/FacturaPdf';
import Layout from '../../components/layout/Layout';

export const FacturaVentaPage = () => {
    return (<Layout children={<Factura />} /> )
}

export const FacturaPdfPage = () => {
    return (<Layout children={<FacturaPdf />} /> )
}
